<div class="event-action-panel">
  <button
    type="button"
    class="event-action-panel__process"
    [class.event-action-panel__process--pressed]="processPressed()"
    [disabled]="actionsDisabled()"
    (click)="onProcessEvent()"
  >
    <div class="event-action-panel__process-main">
      <mat-icon class="event-action-panel__process-icon">notifications_active</mat-icon>
      <span class="event-action-panel__process-label">PROCESS EVENT</span>
    </div>
    <div class="event-action-panel__process-footer">
      {{ queueCount() }} events on Queue
    </div>
  </button>

  <div class="event-action-panel__secondary">
    <button
      type="button"
      class="event-action-panel__secondary-btn"
      [class.event-action-panel__secondary-btn--pressed]="patrolPressed()"
      [disabled]="actionsDisabled()"
      (click)="onManualPatrol()"
    >
      <mat-icon>local_police</mat-icon>
      <span>Manual Patrol</span>
    </button>
    <button
      type="button"
      class="event-action-panel__secondary-btn"
      [class.event-action-panel__secondary-btn--pressed]="siteCheckPressed()"
      [disabled]="actionsDisabled()"
      (click)="onSiteCheck()"
    >
      <mat-icon>videocam</mat-icon>
      <span>Site Check</span>
    </button>
  </div>
</div>
